<template>
    <div class="notification-content">
      <div class="mancontent" @click="OpenOrder">
        {{ messageType }}: {{ taskText }} <br>
        <span class="linkedit">№ заказа: {{ orderId }}</span><br>
        Менеджер: {{ managerLabel }}
      </div>

      <button class="close-button" @click="closeToast">✕</button>
    </div>
  </template>
  
  <script>
  export default {
    name: "Notification",
    props: {
      router: Object,
      messageType: {
        type: String,
        required: true
      },
      taskText: {
        type: String,
        default: "Задача"
      },
      orderId: {
        type: [String, Number],
        required: true
      },
      orderIdLink: {
        type: [String, Number],
        required: true
      },
      managerLabel: {
        type: String,
        default: "Не указан"
      },

        closeToast: Function,
        openOrder: Function 
    },
    methods: {
      OpenOrder() {
        console.log(this.orderIdLink);
        this.openOrder && this.openOrder(this.orderIdLink); 
        console.log('нажад');
      }
    },
  };
  
  </script>
  
  <style scoped>
    .close-button {
      position: absolute;
       top: 4px;
      right: 4px;
       background: transparent;
      border: none;
      color: white;
      font-size: 16px;
      cursor: pointer;
      transition: 0.4s;
    }
    .close-button:hover {
      transform: rotate(180deg);
    }
    .mancontent {
      position: relative;
      left: -10px;
      margin-left: 10px;
      cursor: pointer;
    }
    
    .mancontent:hover .linkedit{
      color: #b4b4b4;
      text-decoration: underline;
    }
  </style>